/**
* Use the Fetch API to access RESTful api resources
*/
module.exports = async (method, endpoint, params, payload) => {

    //
    const endpointURL = new URL(endpoint, location.origin);

    //append any query params
    if (params !== undefined && params !== null) {
        endpointURL.search = new URLSearchParams(params).toString();
    }

    //handle the payload
    const options = ((payload) => {
        if (payload !== undefined && payload !== null) {
            if (payload instanceof FormData) {
                return { 'body': payload };
            }
            return { 'headers': { 'Content-Type': 'application/json' }, 'body': JSON.stringify((payload || {})) };
        }
        return {};
    })(payload);

    //
    const response = await fetch(endpointURL, { 'method': method.toUpperCase(), ...(options || {}) });

    //
    if (response.headers.has('X-FORM-NAME') && response.headers.has('X-FORM-CSRF-TOKEN')) {
        const submittedForm = document.querySelector(`form[name="${response.headers.get('X-FORM-NAME')}"] input[name="form-csrf-token"]`);
        if (submittedForm !== null) {
            submittedForm.value = response.headers.get('X-FORM-CSRF-TOKEN');
        }
    }

    //
    const responseObject = await response.json();
    return [ responseObject.status, responseObject.details ?? responseObject.message ?? responseObject ];

}